import React, { Component } from "react";
class ToggleSwitch extends Component {
    constructor(props) {
        super(props);
        this.state = {
            active: props.initialValue || false
        };
    }

    toggle = () => {
        this.setState(
            prev => ({ active: !prev.active }),
            () => {
                if (this.props.onChange) {
                    this.props.onChange(this.state.active);
                }
            }
        );
    }

    render() {
        const { active } = this.state;
        const { label } = this.props;
        return (
            <div className="toggle-container" onClick={this.toggle}>
                <div className={`toggle-bg ${active ? "on" : "off"}`}>
                    <div className="toggle-circle"/>
                </div>
                {label && <span className="toggle-label">{label}</span>}
            </div>
        );
    }
}

export default ToggleSwitch;